import classNames from "classnames";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { Path, UseFormRegister } from "react-hook-form";
import { twMerge } from "tailwind-merge";
import { TextInputFormFields } from "widgets/shared/TextInputFormFields";

export const error_animation = {
  initial: { opacity: 0, x: -25 },
  animate: { opacity: 1, x: 0 },
  exit: { opacity: 0, y: 0 },
  transition: { duration: 0.4, ease: "easeInOut" },
};
interface TextInputProps {
  id: string;
  label: Path<TextInputFormFields>;
  ariaLabel: string;
  register: UseFormRegister<TextInputFormFields>;
  errors: any;
  disabled?: boolean;
  showLabel?: boolean;
  className?: string;
  inputClassName?: string;
  required?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  id,
  label,
  ariaLabel,
  register,
  errors,
  disabled = false,
  showLabel = true,
  className,
  inputClassName,
  required = false,
}) => {
  return (
    <div
      className={twMerge(
        "gg-flex gg-max-w-full gg-flex-col gg-whitespace-nowrap gg-text-base gg-font-bold gg-leading-6 gg-text-slate-800",
        className,
      )}
    >
      {showLabel && (
        <label htmlFor={id}>
          {label}
          {required && (
            <span className="gg-ml-1 gg-text-lg gg-text-red">*</span>
          )}
        </label>
      )}

      <input
        type="text"
        disabled={disabled}
        id={id}
        className={classNames(
          "gg-mt-2.5 gg-min-h-[3rem] gg-w-full gg-rounded-sm gg-border gg-border-zinc-400 gg-bg-white gg-pl-3 gg-text-base focus:gg-border-transparent focus:gg-outline-none focus:gg-ring-2 focus:gg-ring-dark-blue disabled:gg-border-slate-200 disabled:gg-bg-slate-100 disabled:gg-text-slate-500",
          {
            "gg-border-none gg-border-transparent gg-outline-none gg-ring-2 gg-ring-red-400/70 gg-transition-all gg-ease-in-out focus:gg-ring-red-500":
              errors[label],
          },
          inputClassName,
        )}
        aria-label={ariaLabel}
        aria-invalid={errors.firstName ? "true" : "false"}
        {...register(label)}
      />
      <AnimatePresence mode="wait" initial={false}>
        {errors[label]?.message && (
          <motion.p
            {...error_animation}
            className="gg-mt-1.5 gg-text-xs gg-font-bold gg-text-red-500"
            role="alert"
          >
            {errors[label]?.message}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
};

export default TextInput;
